<template>
    <div class="MovingComponent dataTables">

        <b-form-group id="input-group-Categories" :label="lang.label_Categories+':'" label-for="input-2">
            
            
            <b-form-select v-model="selectedCategory" :options="listCategory" size="sm" class="mt-3"></b-form-select>
            
        </b-form-group>
        
        <br>
        <p v-if="properties.length == 0">{{ lang.infotext_1}}</p>
        <p v-if="properties.length > 0">{{ lang.infotext_2}}:</p>

        <div v-if="properties.length > 0" :id="id">a</div>

        <!-- <LoaderComponent v-show="!isData"></LoaderComponent> -->



    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'

import $ from 'jquery';
import dt from 'datatables.net-bs4';


export default {
    name: "MovingComponent",
    props: {
        lang: Object,
        
    },
    components: {

        LoaderComponent
    },
    data() {
        return {
            name: "MovingComponent",
            mainTable: "",
            properties: [],

            searchTableInput: "",
            selectedCategory: null,
            listCategory: [
                //{ value: null, text: this.lang.select_Placeholder + "..." },
            ]
        }
    },
    computed: {
        ...mapGetters({

            appConf: 'appConf'

        }),
        id() {

            return "place_" + this.name + "_" + this._uid;
        },
        isData() {
            return this.properties != null
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        elementIds() {
            if (this.$store.getters.selectedRows[0] != undefined) {
                if (this.$store.getters.sectionPrefix == "pm") {
                    let selectedRows = [];
                    for (let i = 0, lei = this.$store.getters.selectedRows.length; i < lei; i++) {
                        selectedRows.push(this.$store.getters.selectedRows[i].col___revisionId.partId);
                    }
                    return selectedRows;
                    return this.$store.getters.selectedRows[0].col___revisionId.partId;
                }
                if (this.$store.getters.sectionPrefix == "lm") {
                    let selectedRows = [];
                    for (let i = 0, lei = this.$store.getters.selectedRows.length; i < lei; i++) {
                        selectedRows.push(this.$store.getters.selectedRows[i].col___revisionId.libraryId);
                    }
                    return selectedRows;
                    return this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                }
                if (this.$store.getters.sectionPrefix == "projm") {
                    let selectedRows = [];
                    for (let i = 0, lei = this.$store.getters.selectedRows.length; i < lei; i++) {
                        selectedRows.push(this.$store.getters.selectedRows[i].col___revisionId.projectId);
                    }
                    return selectedRows;
                    return this.$store.getters.selectedRows[0].col___revisionId.projectId;
                }
                
            }
            return ""
        },
        currentCategory() {
            
            let obj = {}
            if (this.$store.getters.sectionPrefix == "pm") {
               
                obj.text = this.$store.getters.selectedRows[0].col___category.category,
                obj.value = this.$store.getters.selectedRows[0].col___category.categoryId
            }
            if (this.$store.getters.sectionPrefix == "lm") {
                
                obj.text = this.$store.getters.selectedRows[0].col___libraryType.category,
                obj.value = this.$store.getters.selectedRows[0].col___libraryType.categoryId,
                obj.categoryType = this.$store.getters.selectedRows[0].col___libraryType.categoryType
                    
            }
            if (this.$store.getters.sectionPrefix == "projm") {
               
                obj.text = this.$store.getters.selectedRows[0].col___category.category,
                obj.value = this.$store.getters.selectedRows[0].col___category.categoryId
            }
            return obj;
        }
    },
    created() {
        
        let vue = this;


        this.$store.dispatch(this.$store.getters.sectionPrefix + '_getFlatCategories')
            .then((result) => {
                console.log(result.data)
                

                if (result.status == "OK") {
                    vue.createCategoriesList(result.data);

                    this.$nextTick(function () {
                        
                        vue.selectedCategory = vue.currentCategory.value;
                    })
                } else {
                    
                }

            })

        


    },
    watch: {
        selectedCategory: function (newVal, oldVal) {
            let vue = this;

            let obj = {
                categoryId: this.selectedCategory
            }
            if (this.$store.getters.sectionPrefix == "pm") {
                obj.partIds = this.elementIds;
            }
            if (this.$store.getters.sectionPrefix == "lm") {
                obj.libraryIds = this.elementIds;
            }
            if(this.$store.getters.sectionPrefix == "projm") {
                obj.projectIds = this.elementIds;
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_bulkCheckMovingToAnotherCategory", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {
                        vue.prepareProperties(result.data);
                    }

                })

            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_moving", obj)
            
        }
        
    },
    updated() {
        

    },
    methods: {
        
        prepareProperties(data) {

            

            for (let i = 0, lei = data.length; i < lei; i++){

                if (this.$store.getters.sectionPrefix == "pm") {
                    data[i].number =  data[i].partNumber;
                }
                if (this.$store.getters.sectionPrefix == "lm") {
                    data[i].number = data[i].libraryNumber;
                }
                if (this.$store.getters.sectionPrefix == "projm") {
                    data[i].number = data[i].projectNumber;
                }
                
            }
            this.properties = data;

            this.$nextTick(function () {
                this.buildTable();

                
            })
            
            
        },        
        createCategoriesList: function (categories) {

            // if (categories.libraryType == this.currentCategory.categoryType) {
            //     const obj = {
            //         text: categories.category,
            //         value: categories.categoryId
            //     }
            //     //this.listCategory.push(obj);
            // }
            
            

            if (categories.children.length > 0) {
                this.categoriesChildren(categories.children);
            }



        },
        categoriesChildren: function (children) {

            for (var i = 0, lei = children.length; i < lei; i++) {

                if (this.currentCategory.categoryType == null) {
                    const obj = {
                        text: children[i].category,
                        value: children[i].categoryId
                    }

                    this.listCategory.push(obj)
                }else if (children[i].libraryType == this.currentCategory.categoryType && children[i].depth >= 2) {
                    const obj = {
                        text: children[i].category,
                        value: children[i].categoryId
                    }

                    this.listCategory.push(obj)
                } else if (children[i].libraryType == this.currentCategory.categoryType && this.currentCategory.categoryType == "generic_files" && children[i].depth > 1) {
                    const obj = {
                        text: children[i].category,
                        value: children[i].categoryId
                    }

                    this.listCategory.push(obj)
                }
                if (children[i].children.length > 0) {
                    this.categoriesChildren(children[i].children);
                }

            }
        },
        buildTable() {
            

            let tableplace = document.getElementById(this.id);
            
            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            let table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            let tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            let thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            let _vue = this;

            let number = "";
            if (this.$store.getters.sectionPrefix == "pm") {
                number = this.lang.table_header_PartNumber;
            }
            if (this.$store.getters.sectionPrefix == "lm") {
                number = this.lang.table_header_LibraryNumber;
            }
            if (this.$store.getters.sectionPrefix == "projm") {
                number = this.lang.table_header_ProjectNumber;
            }

            let columns = [
                {
                    name: number,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Value,
                    alignInColumn: "left",

                },
                


            ]

            let cols = [

                { "data": "number" },
                { "data": "fieldName" },
                { "data": "fieldValue" },


            ]


            let columnDefs = [];
            let len = columns.length;
            
            for (let i = 0; i < len; i++) {
               

                let classname = '_dt-body-' + columns[i].alignInColumn;

                const el = {
                    targets: i,
                    className: classname,

                    render: function ( data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        if (meta.col == 0) {

                            return data;

                        }
                        
                        if (meta.col == 1) {


                            return data;
                        }
                        
                        if (meta.col == 2) {


                            return data;
                        }

                    },


                }

                columnDefs.push(el);



                let th = document.createElement("th");
                tr.appendChild(th);
                let p = document.createElement("p");
                th.appendChild(p);

                let tx = document.createTextNode(columns[i].name)
                p.appendChild(tx);

            }


            const json = {};
            json.paging = true;
            json.info = true;
            json.dom = 'f<t>ip';
            json.data = this.properties;
            json.myColumnFormats = columns;
            json.select = false;
            json.order = [[0, "asc"]];
            json.lengthMenu = [10];
            json.columns = cols;

            json.columnDefs = columnDefs;
            json.initComplete = function () {



            }




            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_' + this.id).DataTable(json);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            //this.mainTable.column(0).visible(false);

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");



        }

    }


}
</script>
<style lang="scss">


//@import "./../../scss/_modal.scss";

.MovingComponent {
    
    table {
        font-size: 0.75rem;
        padding: 0px !important;
        width: 100% !important;
        margin-right: 10px;

    }

    table th {
        padding: 2px !important;
        min-width: 200px;
    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    table {
        .btn {
            padding: 0.15rem 0.5rem;
            margin: 2px;
        }

        .image-library {
            max-width: 40px;
            border-radius: 2px;
            margin-top: 3px;
            margin-right: 3px;
            margin-bottom: 3px;
            background-color: white;
            padding: 2px;
        }

        .badge {
            margin: 3px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/shared/MovingComponent.vue